import React, { Fragment } from 'react';
import { H3, H2, P ,Image} from '../../../../AbstractElements';
import { InvoiceHash,OrderHash, IssuedMay, Koho, PaymentDue,Kohoemail, CORECOLLECTION } from '../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import login from '../../../../assets/images/logo/logo-icon.png'

const OrderHeader = () => {
    
    return (
        <Fragment>
            <div>
                <Row className="invo-header">
                    <Col sm="3">
                        <Media className='d-flex'>
                                <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                                    <Image attrImage={{ className: 'd-flex-object img-fluid', src: "https://www.faraboutique.com/cdn/shop/files/fara-logo-transparent_410x.png?v=1711638276", alt: '' }}
                                    />
                                </Link>
                            
                            
                        </Media>
                    </Col>
                    <Col sm="9">
                        <div className="text-md-end text-xs-center">
                            <H3 className="text-black">
                                {CORECOLLECTION}
                            </H3>
                            <P>
                                {/* {IssuedMay} */}
                                {/* <span className="digits"> 16, 2023</span> */}
                                <br />
                                {/* {PaymentDue}{' '}
                                <span className="digits"> 20, 2023</span> */}
                            </P>
                        </div>
                    </Col>
                </Row>
            </div>
        </Fragment >
    );
};
export default OrderHeader;